<template>
  <chart title="Tariffs Projects" @filtersChanged="update" :apiData="all" />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Chart from '@/components/Chart'

export default {
  name: 'ProjectsTariffsAll',
  components: {
    Chart,
  },
  computed: {
    ...mapState('projects/tariffs', ['all']),
  },
  methods: {
    ...mapActions('projects/tariffs', ['getAll']),
    update({ startDate, endDate }) {
      this.getAll({ startDate, endDate })
    },
  },
}
</script>
